<script setup>
import { onMounted } from 'vue'
import {bbox} from '@turf/turf'
import { v4 as uuidv4 } from 'uuid'
import {MapSource, MapLayer} from '@/components/map'
import { Button } from '@/components/ui/button'
import { ScanEye } from 'lucide-vue-next'

const props = defineProps({
  feature: Object,
  map: Object,
  options: {
    zoomButton: {
      type: Boolean,
      default: false
    },
    zoomToFeature: {
      type: Boolean,
      default: false
    },
    isFill: {
      type: Boolean,
      default: true
    },
  }
})

const uuid = uuidv4()
const type = props.feature.geometry.type
const sourceId = `feature-${uuid}`
const layerId = `feature-${uuid}`
const featureBbox = bbox(props.feature)

const zoomToFeature = () => {
  props.map.fitBounds(featureBbox, { padding: 200, duration: 300 })
}

onMounted(() => {
  console.log(props.feature)
  if (props.feature && props.options.zoomToFeature) {
    zoomToFeature()
  }
})
</script>

<template>
  <div v-if="props.options.zoomButton">
    <Button
      @click="zoomToFeature"
      variant="secondary"
      size="sm"
      class="space-x-1"
    >
      <ScanEye class="w-4 h-4" />
      <span>Zoom to AOI</span>
    </Button>
  </div>
  <MapSource
    v-if="feature"
    :map="map"
    type="geojson"
    :id="sourceId"
    :data="{
      type: 'FeatureCollection',
      features: [feature]
    }"
    :options="{
      'generateId': true
    }"
  >
    <MapLayer
      v-if="props.options.isFill && (type === 'Polygon' || type === 'MultiPolygon')"
      :map="map"
      :id="`${layerId}-fill`"
      type="fill"
      :source="sourceId"
      :options="{
        'paint': {
          'fill-color': '#059669',
          'fill-opacity': 0.1
        },
        'filter': ['==', '$type', 'Polygon']
      }"
    ></MapLayer>

    <MapLayer
      v-if="type === 'Polygon' || type === 'MultiPolygon' || type === 'LineString'"
      :map="map"
      :id="`${layerId}-line`"
      type="line"
      :source="sourceId"
      :options="{
        'paint': {
          'line-color': '#059669',
          'line-width': 3
        },
        'filter': ['==', '$type', 'Polygon']
      }"
    ></MapLayer>

    <MapLayer
      v-if="type === 'Point'"
      :map="map"
      :id="`${layerId}-point`"
      type="circle"
      :source="sourceId"
      :options="{
        'paint': {
          'circle-color': '#059669',
          'circle-radius': 5
        },
        'filter': ['==', '$type', 'Point']
      }"></MapLayer>
  </MapSource>
</template>
